import React from 'react';
import PropTypes from 'prop-types';
import { Text, View } from 'react-native';
import { t } from 'Locale/index';

import defaultStyles from './NoDataText.jss';

const NoDataText = ({ style }) => (
    <View style={[defaultStyles.container, style]}>
        <Text style={defaultStyles.text}>{t('COMMON.NO_DATA')}</Text>
    </View>
);

NoDataText.defaultProps = {
    style: {}
};

NoDataText.propTypes = {
    style: PropTypes.shape({})
};

export default NoDataText;
